import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {FoldDetailService} from '../../../../../../services/apiServices/business/fold-detail.service';
import {SearchService} from '../../../../../../services/apiServices/business/search.service';
import {ActionConfirmKind} from '../../../../../../model/action-confirm-kind';
import {CommonService} from '../../../../../../services/apiServices/business/common.service';

const LIST_FOLD = 'LIST_FOLD';

/**
 * handle actions on fold detail (like retry, discard)
 */
@Component({
  selector: 'app-multi-action-confirm',
  templateUrl: './multi-action-confirm.component.html',
  styleUrls: ['./multi-action-confirm.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MultiActionConfirmComponent implements OnInit {

  /**
   * Const used by back-office for New run request
   */
  public NEWRUN = 'NEWRUN';

  /**
   * Const used by back-office for Restore request
   */
  public RESTORE = 'RESTORE';

  /**
   * Const used by back-office for Exclude request
   */
  public EXCLUDE = 'DISMISSED';

  /**
   * the user choice for displaying Restart or Exclude
   */
  @Input('kindOfActionConfirm') public kindOfActionConfirm: number;

  /**
   * here to perform coherent request
   */
  @Input('folds') public folds;
  @Input('total') public total;
  public notApplicable;

  /**
   * here for updateOrSaveVisible purpose (modal closing)
   */
  @Output() public visible: EventEmitter<boolean>;

  /**
   * the modal title
   */
  public modalTitle: string;

  /**
   * the validation button label
   */
  public buttonLabel: string;

  /**
   * text typed by the user
   */
  public justification: string;

  /**
   * Message title display when action was not perfomed succesfully
   */
  public errorTitle: string;

  /**
   * Message display when action was not perfomed succesfully
   */
  public errorMessage: string;

  /**
   * label for only fold option
   */
  private labelOnlyFold: string;

  /**
   * label for all deposit option
   */
  private labelAllDeposit: string;

  /**
   * list of possible choice (currently : only fold or all deposit)
   */
  public actions: any[];

  /**
   * the selected action (deposit or fold)
   */
  public selectedAction: string;

  public displayMultiConfirmReplay = true;
  /**
   *
   * default constructor, just here for instantiating variables
   *
   * @param {TranslateService} translate - here for translation purposes
   * @param {FoldDetailService} foldDetailService - here to perform request
   * @param {CommonService} commonService - handle notification on succes or error
   * @param {SearchService} searchService - here to perform a search update after success on request
   */
  constructor(private translate: TranslateService, private foldDetailService: FoldDetailService, private commonService: CommonService,
              private searchService: SearchService) {
    this.visible = new EventEmitter<boolean>();
  }

  /**
   * handle context variation on launch
   */
  public ngOnInit(): void {
    this.notApplicable = this.total - this.folds.length;
    this.getTradForNonContextualElement();
    switch (this.kindOfActionConfirm) {
      case ActionConfirmKind.NEWRUN:
        this.tradForNewRun();
        break;
      case ActionConfirmKind.RESTORE:
        this.tradForRestore();
        break;
      case ActionConfirmKind.EXCLUDE:
        this.tradForExclude();
        break;
    }
  }
  /**
   * get the title for exclude modal
   */
  private tradForExclude(): void {
    this.translate.get('FOLD.ACTION_COMPONENT.EXCLUDE_MODAL_TITLE').subscribe((title: string) => {
      this.modalTitle = title;
    });
  }

  /**
   * get the title for nowReun modal
   */
  private tradForNewRun(): void {
    this.translate.get('FOLD.ACTION_COMPONENT.NEWRUN_MODAL_TITLE').subscribe((title: string) => {
      this.modalTitle = title;
    });
  }

  /**
   * get the title for Restore modal
   */
  private tradForRestore(): void {
    this.translate.get('FOLD.ACTION_COMPONENT.RESTORE_MODAL_TITLE').subscribe((title: string) => {
      this.modalTitle = title;
    });
  }

  /**
   * Dispatch request regarding the context
   */
  public processRequest(): void {
    let action;

    switch (this.kindOfActionConfirm) {
      case ActionConfirmKind.NEWRUN:
        action = this.NEWRUN;
        break;
      case ActionConfirmKind.EXCLUDE:
        action = this.EXCLUDE;
        break;
      case ActionConfirmKind.RESTORE:
        action = this.RESTORE;
        break;
    }
    this.handleRequest(action);
  }

  /**
   * perform request and handle return
   */
  private handleRequest(action): void {

    const serialSentList = [];
    for (const fold of this.folds) {
      serialSentList.push(fold.serialSent);
    }

    this.foldDetailService.actionOnFoldList(this.justification, serialSentList, action, LIST_FOLD).subscribe(response => {
      if (response.body.bOK) {
        // noinspection JSUnusedLocalSymbols
        this.searchService.performLastSearch().subscribe(res => {
          this.closeComponent();
        });
      } else {
        this.commonService.addToast({
          life: 3000,
          severity: 'error',
          summary: this.errorTitle,
          detail: this.errorMessage
        });
      }
    });
  }

  /**
   * handle translation for non contextual element (like messages to display in case of fail)
   */
  private getTradForNonContextualElement(): void {
    this.translate.get('COMMON.VALIDATE').subscribe((res: string) => {
      this.buttonLabel = res;
    });
    this.translate.get('TOASTER.ERROR_MESSAGE_TITLE').subscribe((res: string) => {
      this.errorTitle = res;
    });
    this.translate.get('TOASTER.FAIL_REQUEST').subscribe((res: string) => {
      this.errorMessage = res;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.ACTION_CONFIRM_ONLY_FOLD').subscribe((res: string) => {
      this.labelOnlyFold = res;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.ACTION_CONFIRM_FULL_DEPOSIT').subscribe((res: string) => {
      this.labelAllDeposit = res;
    });
  }

  /**
   * spread information about the modal closure to the parent component
   */
  public closeComponent(): void {
    this.displayMultiConfirmReplay = false;
    this.visible.emit(false);
  }
}
